<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      {{ $t("refereeDecisionsList.headline") }}
    </div>
    <ul class="list-group list-group-flush">
      <template
        v-for="(timeSheet, timeSheetIndex) in timeSheets"
        :key="`timeSheet.rD.${timeSheetIndex}`"
      >
        <li
          class="list-group-item disabled bg-light p-1 px-3"
          v-if="timeSheet.refereeDecisions.length > 0 && timeSheets.length > 1"
        >
          {{ timeSheet.title }}
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-start"
          v-for="(
            refereeDecision, refereeDecisionIndex
          ) in timeSheet.refereeDecisions"
          :key="refereeDecisionIndex"
        >
          <div class="me-auto">
            <div class="fw-bold">
              {{ refereeDecision.rule }}
            </div>
            {{ refereeDecision.description }}
          </div>
          <div>
            <span class="badge bg-secondary rounded-pill mx-1"
              >{{ $t("general.flight") }}
              {{ flightNumberById(refereeDecision.flightId) }}
              {{
                refereeDecision.player.length > 0
                  ? ` ➤ ${refereeDecision.player}`
                  : ""
              }}</span
            >
            <span class="badge bg-danger rounded-pill">{{
              refereeDecision.userName
            }}</span>
          </div>
        </li>
      </template>
      <li
        class="list-group-item d-flex justify-content-between align-items-start"
        v-if="refereeDecisions.length == 0"
      >
        <div class="mx-auto">
          <span>{{ $t("refereeDecisionsList.empty") }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    timeSheets: Array,
    flights: Object,
  },
  computed: {
    refereeDecisions() {
      return [].concat(
        ...this.timeSheets?.map((timeSheet) => timeSheet.refereeDecisions ?? [])
      );
    },
  },
  methods: {
    flightNumberById(id) {
      const flight = this.flights.find((f) => f.id == id);
      return flight?.number ?? "n.a.";
    },
  },
});
</script>
